import type { VfConfig } from '#types/config/components/vf'

export default {
  brandClasses: {
    linkVariantDefault: 'underlined',
    linkVariantQuiet: 'hover:underlined'
  }
} satisfies VfConfig['link']
